export const Roles = {
    DEV: "DEVELOPER",
    ORG_ADMIN: "ORG ADMIN",
    ADMIN: "ADMIN"
};
